/* Produktseite Buybox – 7 O'CLOCK (angelegt 01.10.2026)
   1) Preiszeile: Der Versandteil des Theme-Texts („… · kostenloser Versand ab 69 € (DE)") kommt nach
      vorn, „inkl. MwSt" klein dahinter (PAngV-Hinweis bleibt am Preis). Liegt der Produktpreis bei oder
      über der Schwelle, fällt „ab 69 €" weg und der Versandteil wird ein grüner Chip „Kostenloser Versand"
      (Grün wie „Auf Lager", Styles .oc-ship-free / .oc-vat in der CSS).
      Besucher außerhalb Deutschlands (IP-Land über Shopifys Geo-Endpunkt) sehen „Kostenloser Versand (DE)".
      Die Schwelle wird aus dem Text gelesen – ändert ihr den Betrag im Theme-Editor, zieht das mit.
   2) Titel: „Musselin Einzelbettwäsche Beige 135×200cm, Haven" wird am letzten Komma geteilt –
      Kollektionsname („Haven") groß in Zeile 1, der Rest etwas kleiner in Zeile 2. Beide Teile
      bleiben im <h1> (SEO unverändert). Ohne Komma bleibt der Titel wie er ist.
      Styles: assets/custom-product-buybox.css (.oc-title_coll / .oc-title_name). */
(function () {
  'use strict';

  function toNumber(text) {
    var m = (text || '').match(/\d[\d.]*(?:,\d+)?/);
    if (!m) return NaN;
    return parseFloat(m[0].replace(/\./g, '').replace(',', '.'));
  }

  /* Versand-Aktion (04.10.2026, Alina): Gepflegt im Admin unter Inhalte > Metaobjekte > Versand-Aktion.
     Auswahl der Aktion, Kasten-Markup, Uhr und Geo-Erkennung liegen in assets/custom-promo.js
     (window.ocPromo), das global geladen wird – derselbe Kasten erscheint auch im Warenkorb.
     Fehlt das Script, läuft die Seite ohne Aktion weiter. */
  function promoApi() { return window.ocPromo || null; }
  function geoCountry() { var o = promoApi(); return o ? o.geoCountry() : 'DE'; }

  function updateNote() {
    var note = document.querySelector('.sh-price_note');
    var current = document.querySelector('.sh-price_current');
    if (!note || !current) return;
    if (!note.getAttribute('data-oc-original')) note.setAttribute('data-oc-original', note.textContent.trim());
    var original = note.getAttribute('data-oc-original');
    var m = original.match(/\s*ab\s*(\d[\d.]*(?:,\d+)?)\s*€/);
    if (!m) return;
    var threshold = toNumber(m[1]);
    var price = toNumber(current.textContent);
    if (isNaN(threshold) || isNaN(price)) return;
    var promo = promoApi() ? promoApi().active(price) : null;
    var free = !!promo || price >= threshold;
    /* ab Schwelle: „ab 69 €" weg; Versandteil nach vorn (als grüner Chip), „inkl. MwSt" klein dahinter
       (01.10.2026, Alina). Unter der Schwelle: gleicher Aufbau ohne Chip. */
    var text = free ? original.replace(m[0], '').replace(/\s{2,}/g, ' ') : original;
    var sep = text.indexOf('·');
    var vat = sep > -1 ? text.slice(0, sep).trim() : '';
    var ship = sep > -1 ? text.slice(sep + 1).trim() : text;
    ship = ship.charAt(0).toUpperCase() + ship.slice(1); /* „Kostenloser Versand …" */
    if (free && geoCountry() === 'DE') ship = ship.replace(/\s*\(DE\)/, ''); /* in Deutschland ohne „(DE)" */
    var state = (promo ? 'promo:' + JSON.stringify(promo) : free ? 'chip:' : 'plain:') + ship + '|' + vat;
    if (note.getAttribute('data-oc-state') === state) return;
    note.textContent = '';
    var vatEl = null;
    if (vat) {
      vatEl = document.createElement('span');
      vatEl.className = 'oc-vat';
      vatEl.textContent = vat; /* ohne Punkt davor (Alina, 01.10.2026) */
    }
    if (promo) {
      /* Aktionskasten: „inkl. MwSt" bleibt direkt unter dem Preis, darunter der Kasten:
         Icon | Titel + Unterzeile | Trennlinie | Uhr mit Std. Min. Sek. (optional) */
      if (vatEl) { vatEl.className += ' oc-vat--top'; note.appendChild(vatEl); }
      note.appendChild(promoApi().render(promo));
    } else {
      var shipEl = document.createElement('span');
      shipEl.className = free ? 'oc-ship-free' : 'oc-ship-plain';
      shipEl.textContent = ship;
      note.appendChild(shipEl);
      if (vatEl) { note.appendChild(document.createTextNode(' ')); note.appendChild(vatEl); }
    }
    note.setAttribute('data-oc-state', state);
    note.setAttribute('data-oc-promo', promo ? promo.id : '');
  }

  function splitTitle() {
    var h1 = document.querySelector('h1.product-header_heading');
    if (!h1 || h1.querySelector('.oc-title_coll')) return;
    var text = (h1.textContent || '').trim();
    var i = text.lastIndexOf(',');
    if (i < 1 || i === text.length - 1) return;
    var coll = text.slice(i + 1).trim();
    var name = text.slice(0, i).trim();
    if (!coll || !name) return;
    var a = document.createElement('span'); a.className = 'oc-title_coll'; a.textContent = coll;
    var b = document.createElement('span'); b.className = 'oc-title_name'; b.textContent = name;
    h1.textContent = '';
    h1.appendChild(a);
    h1.appendChild(document.createTextNode(' ')); /* Leerzeichen für Screenreader/SEO-Text */
    h1.appendChild(b);
  }

  function init() {
    splitTitle();
    updateNote();
    if (promoApi()) promoApi().onChange(updateNote);
    var current = document.querySelector('.sh-price_current');
    if (current && typeof MutationObserver !== 'undefined') {
      new MutationObserver(updateNote).observe(current, { childList: true, characterData: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* Alpine rendert den Preis ggf. etwas später */
  setTimeout(updateNote, 800);
})();
